import React from 'react';
import { useAppNavigation } from '../../hooks/useAppNavigation';
import { resetMetasiteError } from '../../context/errors';
import { DsBuilderDownError } from './DsBuilderDownError';
import { CATEGORIES_URL } from '../../consts';

export function GeneralError() {
  const { navigate } = useAppNavigation();
  return (
    <DsBuilderDownError
      titleKey="GENERAL_ERROR_TITLE"
      descriptionKey="GENERAL_ERROR_DESCRIPTION"
      tryAgainKey="GENERAL_ERROR_ERROR_BUTTON"
      onTryAgain={() => {
        resetMetasiteError();
        navigate(CATEGORIES_URL);
      }}
      withTryAgain={true}
    />
  );
}
